import { Auth } from "aws-amplify";

export const getUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser(); // Await the promise
    return user.username; // Return the username
  } catch (err) {
    console.log("Error in getUser: ", err);
    return null; // Handle the case where user is not authenticated
  }
};

export const publishLabAPI = async (formData) => {
  const user = await getUser();
  formData.append("username", user);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/publish_lab`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error Exporting Form Entry to PDF: ${error.message}`);
  }
};

export const generateRequirementsForConceptLabRefactored = async (formData) => {
  const user = await getUser();
  formData.append("username", user);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/refactored_generate_requirements_for_concept_lab`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(
      `Error Generating Requirements for Concept Lab: ${error.message}`
    );
  }
};

export const generateIdeasForConceptLabRefactored = async (formData) => {
  const user = await getUser();
  formData.append("username", user);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/refactored_generate_ideas_for_concept_lab`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error Generating Ideas for Concept Lab: ${error.message}`);
  }
};

export const generateStreamlitRequirementsForConceptLab = async (formData) => {
  const user = await getUser();
  formData.append("username", user);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/generate_streamlit_requirements_for_lab`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(
      `Error Generating Streamlit Requirements for Concept Lab: ${error.message}`
    );
  }
};
